<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 17:05:51
 * @LastEditTime: 2019-08-22 10:34:02
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">报销统计</div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="已申请报销统计" name="1">
        <el-form ref="form" :model="form" label-width="120px" :inline="true">
          <el-form-item label="申请报销时间:">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form.start_time"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form.end_time"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="礼品名称:">
            <el-input v-model="form.keywords" clearable></el-input>
          </el-form-item>
          <el-form-item label="报销状态:">
            <el-select v-model="form.type" clearable placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option key="2" label="已完成报销" value="20"></el-option>
              <el-option key="3" label="拒绝报销" value="30"></el-option>
              <el-option key="4" label="等待报销" value="10"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <el-button type="primary" @click="onExport()">导出</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 10px">
          总记录数: {{ total }}，报销总数:{{ outstock }}
        </div>

        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="loading"
          border
          stripe
          style="width: 100%; margin: 20px"
        >
          <el-table-column prop="product_image" label="礼品图片">
            <template slot-scope="scope">
              <div>
                <img :src="scope.row.product_image" height="50" width="50" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_number" label="礼品编号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="product_name" label="礼品名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="expenses_status" label="报销状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.expenses_status == 10">等待报销</span>
              <span v-if="scope.row.expenses_status == 20" style="color: green"
                >已完成报销</span
              >
              <span v-if="scope.row.expenses_status == 30" style="color: red"
                >拒绝报销</span
              ><br />
              <span v-if="scope.row.expenses_status == 30">
                <a href="JavaScript:;" @click="getDetail(scope.row)">查看原因</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="expense_num" label="报销数量" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="create_time" label="报销时间" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="remarks" label="描述" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="" label="操作" width="240" show-overflow-tooltip>
            <template slot-scope="scope">
              <a href="JavaScript:;" @click="getDetail(scope.row)">查看明细</a>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="未申请报销统计" name="2">
        <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <el-form-item label="礼品名称:">
            <el-input v-model="form1.keywords" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <!-- <el-button type="primary" @click="onExport()">导出</el-button> -->
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 10px">
          未申报总数:{{ sum_not_expense_num }},已申报总数:
          {{ sum_already_expense_num }},申报成功总数:{{ sum_already_suc_expense_num }}
        </div>

        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          border
          stripe
          style="width: 100%; margin: 20px"
        >
          <el-table-column prop="product_image" label="礼品图片">
            <template slot-scope="scope">
              <div>
                <img :src="scope.row.product_image" height="50" width="50" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_number" label="礼品编号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="product_name" label="礼品名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="not_expense_num" label="未申报数" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="already_expense_num"
            label="已申报数"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="already_success_expense_num"
            label="申报成功数"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="detail" width="30%" title="拒绝原因">
      <span>{{ remark }}</span>
    </el-dialog>
  </div>
</template>

<script>
import copyLinkDialog from "@/common/copyLinkDialog";

export default {
  name: "dealer_expense_statistic",
  data() {
    return {
      loading: false,
      activeName: "1",
      form1: {
        start_time: "",
        end_time: "",
        keywords: "",
      },
      form: {
        start_time: "",
        end_time: "",
        keywords: "",
        type: "",
      },
      tableData1: [],
      tableData: [],
      tableData2: [],
      //分页
      pageNo1: 1, //页码
      pageSize1: 20, //每页现实的条数
      totalSize1: 0, //总条数
      //分页
      pageNo: 1, //页码
      pageSize: 20, //每页现实的条数
      totalSize: 0, //总条数
      total: 0,
      outstock: 0,
      remark: "",
      detail: false,
      sum_already_expense_num: 0,
      sum_already_suc_expense_num: 0,
      sum_not_expense_num: 0,
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    onSearch() {
      this.loading = true;
      if (this.activeName == 1) {
        let beginstr = "",
          endstr = "";
        if (this.form.start_time) {
          this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
        }
        if (this.form.end_time) {
          this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
        }
        this.$get("logistics_2", "/vstore/dealer_pc/dealerAlreadyExpense", {
          ...this.form,
          per_page: this.pageSize,
          page: this.pageNo,
          channel: 1,
          is_export: 0,
        })
          .then((res) => {
            this.loading = false;
            this.tableData = res.data.data;
            this.totalSize = res.data.total;
            this.total = res.data.total;
            this.outstock = res.data.expense_num;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        let beginstr = "",
          endstr = "";
        if (this.form1.start_time) {
          this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD");
        }
        if (this.form1.end_time) {
          this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
        this.$get("logistics_2", "/vstore/dealer_pc/dealerNotExpense", {
          ...this.form1,
          per_page: this.pageSize1,
          page: this.pageNo1,
          channel: 1,
          is_export: 0,
        }).then((res) => {
          this.loading = false;
          this.tableData1 = res.data.data;
          this.totalSize1 = res.data.total;
          this.total = res.data.total;
          this.sum_already_expense_num = res.data.sum_already_expense_num;
          this.sum_already_suc_expense_num = res.data.sum_already_suc_expense_num;
          this.sum_not_expense_num = res.data.sum_not_expense_num;
        });
      }
    },
    onExport() {
      let url = "",
        access_tokens = localStorage.getItem("access_token");

      if (this.activeName == 1) {
        let beginstr = "",
          endstr = "";
        if (this.form.start_time) {
          beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
        }
        if (this.form.end_time) {
          endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
        }
        // console.log(
        //   "http://ppcs.com/index.php/publics" +
        //     "/vstore/dealer_pc/dealerAlreadyExpense?" +
        //     "lang=" +
        //     "" +
        //     "&is_export=1" +
        //     "&start_time=" +
        //     beginstr +
        //     "&end_time=" +
        //     endstr +
        //     "&keywords=" +
        //     this.form.keywords +
        //     "&type=" +
        //     this.form.type +
        //     "&channel=1" +
        //     "&signature=" +
        //     this.$md5(access_tokens)
        // );
        // return;
        window.open(
          this.apis.logistics_2 +
            "vstore/dealer_pc/dealerAlreadyExpense?" +
            "lang=" +
            "" +
            "&is_export=1" +
            "&start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&keywords=" +
            this.form.keywords +
            "&type=" +
            this.form.type +
            "&channel=1" +
            "&signature=Bearer " +
            access_tokens
        );
      } else {
        let beginstr = "",
          endstr = "";
        if (this.form1.start_time) {
          beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
        }
        if (this.form1.end_time) {
          endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
        window.open(
          process.env.VUE_APP_URL_V1 +
            "/retail/return.export?" +
            "lang=" +
            "" +
            "&is_export=1" +
            "&start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&keywords=" +
            this.form1.keywords +
            "&channel=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    getDetail(data) {
      this.detail = true;
      this.remark = data.remark;
      console.log(this.remark);
    },
    Detailexport() {
      let url = "",
        access_tokens = localStorage.getItem("access_token");
      if (process.env.NODE_ENV == "development") {
        url = "http://dealer.c.qiema.cc/dealer/v1";
      } else if (process.env.NODE_ENV == "production") {
        url = "http://dealer.api.qiema.cn/dealer/v1";
      } else {
        url = "http://dealer.api.qiema.cn/dealer/v1";
      }

      if (this.activeName == 1) {
        window.open(
          url +
            "/retail/" +
            this.detailData.stock_out_sn +
            "/productdata.export?" +
            "lang=" +
            "" +
            "&is_export=1" +
            "&keywords=" +
            this.form1.keywords +
            "&channel=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        window.open(
          url +
            "/retail/" +
            this.detailData.return_goods_sn +
            "/productdata.export?" +
            "lang=" +
            "" +
            "&is_export=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    handleClick(tab) {},
    handleSizeChange1(val) {
      this.pageSize = val;
      this.pageNo = 1;
      //this.getDealerList();
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo = val;
      //this.getDealerList();
      this.onSearch();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      //this.getGoodsList();
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
      //this.getGoodsList();
      //this.getGoodsList();
    },
    handleClick() {
      this.onSearch();
    },
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.form1.start_time = this.getLastMonth().last;
    this.form1.end_time = this.getLastMonth().now;
    this.onSearch();
  },
};
</script>

<style lang="scss" scoped>
.block {
  height: 100px;
  line-height: 24px;
  background-color: #eee;
  padding-left: 20px;
  margin-bottom: 20px;
}
</style>
